import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { DEALER } from "@/data/dealer";

export const MapFrame = ({ className, testId = "map-frame" }) => (
  <div className={cn("relative overflow-hidden rounded-lg border border-line bg-paper", className)} data-testid={testId}>
    <iframe
      title="Map showing YK Motors, Muse House, Peterborough PE1 5YD"
      src={DEALER.mapEmbed}
      loading="lazy"
      tabIndex={-1}
      className="pointer-events-none absolute inset-0 h-full w-full grayscale-[0.35]"
    />
    <a
      href={DEALER.mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-dark btn-sm absolute bottom-4 left-4"
      data-testid={`${testId}-directions-link`}
    >
      Open in Google Maps <ArrowUpRight aria-hidden="true" />
    </a>
  </div>
);
